export class PaginationTranslations {
  public previous?: string;
  public next?: string;
  public of?: string;
  public page: string;
  public jumpToPage: string;
  public results?: string;

  constructor(obj?: PaginationTranslations) {
    obj = obj || ({} as PaginationTranslations);
    this.previous = obj.previous || 'Previous';
    this.next = obj.next || 'Next';
    this.of = obj.of || 'of';
    this.page = obj.page || 'Page';
    this.jumpToPage = obj.jumpToPage || 'Jump to page';
    this.results = obj.results || 'results';
  }
}
